import { render, staticRenderFns } from "./SmallCollapsePanel.vue?vue&type=template&id=589c49cf&scoped=true"
import script from "./SmallCollapsePanel.vue?vue&type=script&lang=js"
export * from "./SmallCollapsePanel.vue?vue&type=script&lang=js"
import style0 from "./SmallCollapsePanel.vue?vue&type=style&index=0&id=589c49cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589c49cf",
  null
  
)

export default component.exports